/**
 * Generate a unique ID for temporary use in the frontend
 * @returns {string} A unique ID string
 */
export const generateId = () => {
  return `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};

/**
 * Check if an ID is a temporary ID (generated on the frontend)
 * @param {string} id - The ID to check
 * @returns {boolean} True if it's a temporary ID
 */
export const isTemporaryId = (id) => {
  return typeof id === "string" && id.startsWith("temp_");
};
